/**
 * Helper Plausible Analytics — events 100% anonymes (aucun cookie, aucune IP stockée).
 * Pas besoin de consentement RGPD pour ces events.
 */

type PlausibleFn = ((event: string, options?: { props?: Record<string, string | number | boolean> }) => void) & {
  q?: unknown[];
};

declare global {
  interface Window {
    plausible?: PlausibleFn;
  }
}

export type AnalyticsEvent =
  | "step_1_completed"
  | "step_2_completed"
  | "step_3_completed"
  | "step_4_completed"
  | "email_captured"
  | "affiliate_click"
  | "pdf_downloaded"
  | "simulation_saved"
  | "simulation_loaded";

export function trackEvent(
  name: AnalyticsEvent,
  props?: Record<string, string | number | boolean>
) {
  if (typeof window === "undefined") return;
  try {
    if (window.plausible) {
      window.plausible(name, props ? { props } : undefined);
    }
    // Fallback console pour dev
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log(`[Analytics] ${name}`, props ?? "");
    }
  } catch {
    /* no-op */
  }
}
